<template>
    <div class="formWrapper">
        <div
            id="dropZone"
            :class="{ highlight, error, loading: !!loadingStatus, shadow: true }"
            @drop.stop.prevent="handleDrop"
            @dragenter.stop.prevent="highlight = true"
            @dragleave.stop.prevent="highlight = false"
            @dragover.stop.prevent="highlight = true"
        >
            <input
                ref="fileUpload"
                type="file"
                id="fileInput"
                accept=".pdf,.docx,.txt"
                @change="handleUpload"
            />
            <template v-if="error">
                <div class="errorText">{{ error }}</div>
                <img id="joebot" src="/img/joe_bot.png" alt="Jobscan Robot" />
            </template>
            <template v-else-if="loadingStatus">
                <div class="statusTitle">Scanning...</div>
                <div class="statusText">{{ loadingStatus }}</div>
                <ProgressBar :progress="loadingProgress" maxWidth="400px" />
            </template>
            <template v-else>
                <div class="documentIcon">
                    <img src="/img/icons/document.svg" alt="document icon" />
                </div>
                <p>Upload your resume to discover the next step in your career</p>
                <button class="swell" @click="openFileDialog" for="fileElem">
                    Upload your resume
                </button>
                <span class="types">as .pdf or .docx file</span>
                <img id="joebot" src="/img/joe_bot.png" alt="Jobscan Robot" />
            </template>
            <!-- <img id="joebot" src="/img/joe_bot.png" alt="Jobscan Robot" /> -->
        </div>
        <span class="formToggle" @click="$emit('toggleForm')">Or paste resume text</span>
    </div>
</template>

<script>
import ProgressBar from '../../components/ProgressBar'
import { uploadFile, getJDMatches } from '../../api/genericJobs'
export default {
    name: 'FileUploader',
    components: { ProgressBar },
    data() {
        return {
            highlight: false,
            error: null,
            loadingStatus: null,
            loadingProgress: 0,
            jobRecs: [],
        }
    },
    watch: {
        error: function(val) {
            if (val) {
                setTimeout(() => {
                    this.error = null
                }, 3500)
            }
        },
    },
    methods: {
        evaluateFile(fileList) {
            let resp = { error: null }
            const allowedFileTypes = ['docx', 'pdf', 'txt']

            if (!fileList.length) {
                resp.error = 'Whoops, that doesn’t look like a file.'
                return resp
            }

            const file = fileList[0]
            const fileExt = file.name
                .split('.')
                .pop()
                .toLowerCase()

            if (allowedFileTypes.includes(fileExt)) {
                return resp
            } else {
                resp.error = `Unable to upload a [.${fileExt}] file. Please ensure your file is formatted correctly.`
                return resp
            }
        },
        handleDrop(e) {
            const fileList = e.dataTransfer.files
            this.handleFileList(fileList)
            this.highlight = false
        },
        handleUpload(e) {
            const fileList = e.target.files
            this.handleFileList(fileList)
        },
        openFileDialog() {
            this.$refs.fileUpload.click()
        },
        handleFileList: async function(fileList) {
            const { error } = this.evaluateFile(fileList)
            if (error) {
                this.error = error
                return
            }
            // 1. convert to text
            const fileText = await this.uploadFile(fileList[0])
            // 2. send to API
            const JDMatches = await this.getJDMatches(fileText)
            // 3. navigate to results with params
            this.$router.push({
                name: 'CareerShiftResults',
                params: { recommendations: JDMatches.jds, skills: JDMatches.skills },
            })
        },
        uploadFile: async function(file) {
            setTimeout(() => (this.loadingProgress = 50), 200)
            // this.loadingProgress = 50;
            this.loadingStatus = 'Analyzing your resume...'
            const { error, data } = await uploadFile(file)
            if (error) {
                this.error = 'We were not able to upload your resume. Please try again!'
            }
            localStorage.career_change_cv = data.data.text
            return data.data.text
        },
        getJDMatches: async function(text) {
            this.loadingStatus = 'Fetching recommendations...'
            this.loadingProgress = 100
            const { error, data } = await getJDMatches(text)
            return data.data
        },
    },
}
</script>

<style lang="less" scoped>
.formWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
#fileInput {
    display: none;
}
#dropZone {
    position: relative;
    border: dashed 2px #7eccf2;
    background-color: white;
    padding: 1em;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 320px;
    overflow: hidden;
    width: 100%;
    &.highlight {
        border-style: solid;
        background-color: #f0f8ff;
        transform: scale(1.05);
        transition: all 0.1s;
    }
    &.error {
        border-color: #ff6565;
        background-color: #fff5f5;
        img#joebot {
            transform: translate3d(30%, 40%, 0) rotate(-25deg);
        }
    }
    button {
        padding: 1em 2.5em;
        color: white;
        font-weight: 600;
        font-size: 0.9em;
        background-color: #2aacea;
        border: none;
        margin-bottom: 0.25em;
    }
    .documentIcon {
        width: 64px;
        height: 64px;
        padding: 18px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #2aacea;
        background-color: rgba(42, 172, 234, 0.15);
        margin-bottom: 1em;
        border-radius: 50%;
    }
    p {
        font-weight: bold;
    }
    .types {
        font-size: 0.9em;
    }
    .errorText {
        display: block;
        width: calc(100% - 30px);
        max-width: 360px;
        text-align: center;
    }
    .statusTitle {
        display: block;
        width: calc(100% - 30px);
        text-align: center;
        font-weight: 300;
        font-size: 2.25em;
        margin-bottom: 0.25em;
        line-height: 1.1em;
    }
    .statusText {
        display: block;
        width: calc(100% - 30px);
        text-align: center;
        font-weight: 500;
        font-size: 1em;
        font-style: italic;
        margin-bottom: 1.75em;
    }
    img#joebot {
        position: absolute;
        bottom: 0;
        right: 1em;
        width: 150px;
        max-width: 25vw;
        transform-origin: center center;
        transition: 500ms ease-in-out;
    }
}

.formToggle {
    font-size: 0.9em;
    color: #2aacea;
    cursor: pointer;
    margin-top: 0.75em;
}

@media screen and (max-width: 768px) {
    #dropZone {
        padding: 2em;
        img#joebot {
            position: absolute;
            bottom: 0;
            right: -2em;
            width: 150px;
            max-width: 25vw;
            transform-origin: center center;
            transition: 500ms ease-in-out;
        }
    }
}
</style>
